import { render, staticRenderFns } from "./FIFProcessResults.vue?vue&type=template&id=3cb68a1a&"
import script from "./FIFProcessResults.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FIFProcessResults.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./FIFProcessResults.vue?vue&type=style&index=0&id=3cb68a1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports